core-textarea {
  display: block;
}

.core-textarea {
  --border-width: 1px;
  --outline-width: 2px;
  --outline-offset: 2px;
  display: flex;
}

.core-textarea .textarea-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
}

.core-textarea.textarea-disabled .textarea-field {
  pointer-events: none;
  background: var(--color-global-all-disabled-soft);
  color: var(--color-global-all-disabled-strong);
  border-color: transparent;
}

.core-textarea.textarea-disabled:hover {
  cursor: not-allowed;
}

.core-textarea.textarea-in-error .textarea-field {
  padding: calc(var(--number-spacing-2xsmall) - var(--border-width)) calc(var(--number-spacing-2xlarge) - var(--border-width)) calc(var(--number-spacing-2xsmall) - var(--border-width)) calc(var(--number-spacing-2xsmall) - var(--border-width));
}

.core-textarea.textarea-format--outside .textarea-field, .core-textarea.textarea-format--aside .textarea-field, .core-textarea.textarea-format--hidden .textarea-field {
  padding: calc(var(--number-spacing-2xsmall) - var(--border-width));
}

.core-textarea.textarea-format--outside {
  flex-direction: column;
}

.core-textarea.textarea-format--aside {
  flex-direction: row;
}

.core-textarea .textarea-header {
  display: flex;
  flex-direction: column;
}

.core-textarea.textarea-format--outside .textarea-header {
  padding: var(--number-spacing-none) var(--number-spacing-4xsmall) var(--number-spacing-4xsmall) var(--number-spacing-4xsmall);
}

.core-textarea.textarea-format--aside .textarea-header {
  flex: 1;
  padding-right: var(--number-spacing-small);
  justify-content: center;
}

.core-textarea.textarea-format--aside .textarea-wrapper {
  flex: 1;
}

.core-textarea.textarea-format--inside .textarea-wrapper, .core-textarea.textarea-format--outside .textarea-wrapper {
  width: 100%;
}

.core-textarea .label {
  display: flex;
  align-items: center;
  color: var(--color-edition-content-default);
  transition: color var(--motion-duration-fast) var(--motion-easing-move);
}

.core-textarea .description {
  color: var(--color-neutral-content-medium);
}

.core-textarea.textarea-in-error .label {
  color: var(--color-status-content-error);
}

.core-textarea .field-requirement {
  padding-left: var(--number-spacing-4xsmall);
}

.core-textarea .error-message {
  padding: var(--number-spacing-4xsmall) var(--number-spacing-4xsmall) var(--number-spacing-none) var(--number-spacing-4xsmall);
  color: var(--color-status-content-error);
}

.core-textarea .textarea-field {
  display: flex;
  border-radius: var(--number-radius-small);
  border: var(--border-width) solid var(--color-edition-border-default);
  background: var(--color-edition-background-default);
  color: var(--color-neutral-content-strong);
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
    color var(--motion-duration-fast) var(--motion-easing-move),
    border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-textarea textarea {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  letter-spacing: inherit;
  text-decoration: inherit;
  text-indent: inherit;
  text-overflow: inherit;
  text-transform: inherit;
  text-align: inherit;
  white-space: inherit;
  color: inherit;
  display: inline-block;
  position: relative;
  flex: 1;
  width: 100%;
  max-width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  box-sizing: border-box;
  appearance: none;
  z-index: 1;
  resize: vertical;
}

.core-textarea textarea::placeholder {
  color: var(--color-neutral-content-strong);
  /* mozilla is applying transparency on placeholder */
  opacity: 0.65;
}

.core-textarea textarea:disabled::placeholder {
  color: var(--color-global-all-disabled-strong);
  /* mozilla is applying transparency on placeholder */
  opacity: 1;
}

.core-textarea .textarea-field:not(.textarea-in-error .textarea-field):hover, .core-textarea.textarea-focus .textarea-field:not(.textarea-in-error .textarea-field) {
  border: var(--border-width) solid var(--color-edition-border-interacting);
  color: var(--color-neutral-content-strong);
}

.core-textarea.textarea-focus .textarea-field:focus-visible {
  outline: var(--outline-width) solid var(--color-global-border-focus);
  outline-offset: var(--outline-offset);
}

.core-textarea:has(.textarea-field:not(.textarea-in-error .textarea-field):hover) .label, .core-textarea.textarea-focus:not(.textarea-focus.textarea-in-error) .label {
  color: var(--color-edition-content-interacting);
}

.core-textarea .field-content {
  position: relative;
  display: block;
}

.core-textarea .field-indicator {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  height: fit-content;
  z-index: 1;
  padding-top: var(--number-spacing-2xsmall);
  padding-right: var(--number-spacing-2xsmall);
  cursor: default;
}

.core-textarea .icon-box {
  display: flex;
  padding: var(--number-spacing-5xsmall);
}
